module.exports = __webpack_public_path__ + "static/img/zjgn03.7f25dd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/zjgn03.jpg
// module id = 1426
// module chunks = 0